import { render, staticRenderFns } from "./ReferralRegister.vue?vue&type=template&id=98f980b8&scoped=true"
import script from "./ReferralRegister.vue?vue&type=script&lang=js"
export * from "./ReferralRegister.vue?vue&type=script&lang=js"
import style0 from "./ReferralRegister.vue?vue&type=style&index=0&id=98f980b8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f980b8",
  null
  
)

export default component.exports